import React from 'react';
import styles from './Primitives.module.scss';

export interface PlaceholderMessageProps {
  /** Text or node to display */
  message: React.ReactNode;
  /** Additional class(es) applied to the wrapper; these are appended so you can override styling */
  className?: string;
  style?: React.CSSProperties;
}

export const PlaceholderMessage: React.FC<PlaceholderMessageProps> = ({ message, className = '', style }) => {
  return (
    <div className={`${styles.placeHolderMessage} ${className}`} style={style}>
      {message}
    </div>
  );
};
